export default __webpack_public_path__ + "static/media/icon-login.00c38238.svg";